import { render, staticRenderFns } from "./Importance_panel.vue?vue&type=template&id=2d6334d9&scoped=true&"
import script from "./Importance_panel.vue?vue&type=script&lang=js&"
export * from "./Importance_panel.vue?vue&type=script&lang=js&"
import style0 from "./Importance_panel.vue?vue&type=style&index=0&id=2d6334d9&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6334d9",
  null
  
)

component.options.__file = "Importance_panel.vue"
export default component.exports